import { useEffect, useState } from 'react';
export const useDeviceOrientation = () => {
    const [heading, setHeading] = useState(null);
    const [error, setError] = useState(null);
    useEffect(() => {
        const handleOrientation = (event) => {
            const newHeading = event.alpha;
            if (newHeading !== null) {
                setHeading(newHeading);
            }
        };
        const startListening = () => {
            window.addEventListener('deviceorientation', handleOrientation, true);
        };
        const stopListening = () => {
            window.removeEventListener('deviceorientation', handleOrientation, true);
        };
        // iOS 13+ permission request
        const requestPermission = DeviceOrientationEvent.requestPermission;
        if (typeof requestPermission === 'function') {
            requestPermission()
                .then((response) => {
                if (response === 'granted') {
                    startListening();
                }
                else {
                    setError('Permission to access device orientation was denied.');
                }
            })
                .catch(() => {
                setError('Permission request failed.');
            });
        }
        else {
            // Non-iOS devices or no permission needed
            startListening();
        }
        return () => stopListening();
    }, []);
    return { heading, error };
};
